import * as helios from "@hyperionbt/helios"
import common from "./common.hl"
//wraps helios.Program
export default class Program {
    #program

    constructor(parameters = {}) {
        // load all the dependencies
        const allDeps = [common]

        const depSrcs = new Map()

        function addDepSrcs(dep) {
            depSrcs.set(dep.name, dep.src)

            for (let d of dep.dependencies) {
                addDepSrcs(d)
            }
        }

        for (let d of allDeps) {
            addDepSrcs(d)
        }

        this.#program = helios.Program.new(`spending artwork

import {
  TOKEN_NAME_AUTH,
  DatumArtwork as Datum
} from common

enum Redeemer {
  Update
  Mint
}

// We accept double satisfaction here as it requires both
// owner & mod keys to create a clone UTxO.
// TODO: Do not sign on a create-artwork transaction that
// duplicates an existed authentic UTxO.
//
// We allow consuming multiple UTxOs in the same transaction
// so large collectors don't have to mint one by one.
//
func main(own_datum: Datum, redeemer: Redeemer, ctx: ScriptContext) -> Bool {
  // Strict check to only consume a UTxO with only auth token
  // as (non-lovelace) asset.
  own_output: TxOutput = ctx.get_current_input().output;
  own_assets: Map[MintingPolicyHash]Map[ByteArray]Int = own_output.value.get_assets().to_map();
  assert(own_assets.length == 1, "Expect exactly one collection");
  own_tokens: Map[ByteArray]Int = own_assets.head_value;
  assert(
    own_tokens.length == 1 &&
    own_tokens.head_key == TOKEN_NAME_AUTH,
    "Expect only auth token"
  );

  next_datum: Datum = ctx.tx.outputs
    .filter((output: TxOutput) -> {
      output.address == own_output.address &&
      output.value.get_assets() == own_output.value.get_assets() &&
      output.value.get_lovelace() >= own_output.value.get_lovelace()
    })
    .map((output: TxOutput) -> {
      output.datum.switch {
        i: Inline => Datum::from_data(i.data),
        else => error("Invalid artwork output: missing inline datum")
      }
    })
    .find((datum: Datum) -> {
      datum.owner_address == own_datum.owner_address &&
      datum.collection_id == own_datum.collection_id &&
      datum.token_name == own_datum.token_name
    });
  redeemer.switch {
    Update => {
      own_datum.owner_address.credential.switch {
        pk: PubKey => assert(ctx.tx.is_signed_by(pk.hash), "Missing signature"),
        else => error("Invalid owner address")
      };

      next_datum.mint_fee >= 0 &&
      next_datum.num_minted == own_datum.num_minted &&
      next_datum.num_minted <= next_datum.num_editions
    },
    Mint => {
      minted_artworks: Int = ctx.tx.minted.get(
        AssetClass::new(own_assets.head_key, own_datum.token_name)
      );

      next_datum.mint_fee == own_datum.mint_fee &&
      next_datum.num_editions == own_datum.num_editions &&
      next_datum.num_minted == own_datum.num_minted + minted_artworks &&
      next_datum.num_minted <= next_datum.num_editions
    }
  }
}
`, Array.from(depSrcs.values()))

        if (Object.keys(parameters).length > 0) {
            this.#program.parameters = parameters
        }
    }

    get name() {
        return this.#program.name
    }

    get paramTypes() {
        return this.#program.paramTypes
    }

    get parameters() {
        return this.#program.parameters
    }

    get types() {
        return this.#program.types
    }

    set parameters(params) {
        this.#program.parameters = params
    }

    compile(optimize = false) {
        return this.#program.compile(optimize)
    }

    evalParam(paramName) {
        return this.#program.evalParam(paramName)
    }
}
